import { API, axiosInstance } from "lib";

export const getUserList = (data = {}) => {
  // const queryParams = new URLSearchParams({
  //   userId: data?.userId || "",
  //   birdId: data?.birdId || "",
  //   startDate: data?.startDate || "",
  //   endDate: data?.endDate || "",
  //   page: data?.page || 1,
  //   userRole: data?.userRole || "",
  //   isActive: data?.isActive ?? "",
  //   limit: data?.limit || null,
  //   keyword: data?.keyword || "",
  //   isEmailVerified: data?.isEmailVerified || "",
  // });

  const params = {
    userId: data?.userId || "",
    birdId: data?.birdId || "",
    startDate: data?.startDate || "",
    endDate: data?.endDate || "",
    page: data?.page || 1,
    userRole: data?.userRole || "",
    isActive: data?.isActive ?? "",
    limit: data?.limit || null,
    keyword: data?.keyword || "",
  };

  if (data?.isEmailVerified !== undefined && data?.isEmailVerified !== null) {
    params.isEmailVerified = data.isEmailVerified;
  }

  const queryParams = new URLSearchParams(params);

  return axiosInstance
    .get(`${API.GET_USER_LIST}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.error("Error fetching user list:", err);
      throw err;
    });
};

export const getUserDetails = (data = {}) => {
  return axiosInstance
    .get(
      API.GET_USER_DETAIL +
        `?` +
        `userId=${data?.userId}&userIdToRetrive=${data?.userIdToRetrive}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      throw err;
    });
};

export const deleteUserData = (data = {}) => {
  return axiosInstance
    .post(API.DELETE_USER_DATA, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
      }
      throw err;
    });
};

export const updateUserProfile = (data = {}) => {
  return axiosInstance
    .post(API.EDIT_USER_DATA, data)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
};

export const addUserProfile = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_USER_DATA, data)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
};

export const toggleUserActiveStatus = (data = {}) => {
  return axiosInstance
    .post(API.TOGGLE_USER_ACTIVE, data)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
};

export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance
    .post(API.UPLOAD_USERFILE, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data)
    .catch((err) => {
      console.error("Error uploading file:", err);
      throw err;
    });
};

export const getDeletedUserList = (data = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("userId", data?.userId);
  queryParams.append("page", data?.page);
  queryParams.append("limit", data?.limit || null);
  queryParams.append("keyword", data?.keyword || "");

  if (Array.isArray(data?.categoryIds)) {
    data.categoryIds.forEach((id) => {
      queryParams.append("categoryIds[]", id);
    });
  }

  return axiosInstance
    .get(`${API.GET_DELETED_USER_LIST}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};